import {CSSProperties, FC} from 'react';


export interface IIconViberProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconViber: FC<IIconViberProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12.116.232C5.588.232.296 5.524.296 12.052c0 6.527 5.292 11.82 11.82 11.82 6.527 0 11.82-5.293 11.82-11.82 0-6.528-5.293-11.82-11.82-11.82Zm-.554 6.244c.097-.088.164-.1.498-.09.174.006.43.027.57.043a5.705 5.705 0 0 1 1.897.563c.614.301 1.008.586 1.528 1.104.487.49.757.86 1.044 1.435.399.803.626 1.757.665 2.807.015.359.004.438-.078.54-.155.2-.497.167-.614-.057-.037-.073-.047-.137-.06-.423a7.436 7.436 0 0 0-.112-1.065C16.66 10 16.02 8.935 15 8.172c-.85-.64-1.728-.95-2.879-1.018-.389-.022-.456-.037-.544-.104-.164-.13-.172-.432-.015-.574Zm2.44 2.637c-.41-.245-1.019-.427-1.574-.472-.2-.017-.31-.058-.387-.146a.373.373 0 0 1-.03-.463c.106-.165.27-.192.76-.118 1.242.182 2.204.76 2.835 1.697a4.07 4.07 0 0 1 .651 1.814c.027.244.027.688-.002.762a.467.467 0 0 1-.186.203.458.458 0 0 1-.344-.013c-.158-.08-.205-.207-.205-.55 0-.53-.137-1.09-.375-1.524a3.111 3.111 0 0 0-1.142-1.19Zm.693 2.73c-.12.11-.344.114-.48.01-.098-.074-.128-.152-.15-.362a1.946 1.946 0 0 0-.16-.66c-.18-.387-.498-.587-1.034-.653-.252-.03-.328-.06-.41-.155a.382.382 0 0 1 .115-.574c.078-.039.11-.043.282-.032.107.006.264.024.348.043.404.086.713.24.977.487.34.321.526.71.608 1.27.056.364.033.507-.096.626Zm3.059 5.379c-.152.39-.741 1.124-1.153 1.437-.372.283-.637.391-.985.407-.286.015-.405-.01-.772-.161-2.874-1.186-5.17-2.955-6.992-5.385-.952-1.27-1.677-2.586-2.172-3.952-.289-.796-.303-1.142-.066-1.55.103-.172.539-.598.856-.835.528-.393.772-.539.967-.58.133-.028.364-.006.511.047.072.025.183.082.246.123.39.258 1.472 1.644 1.826 2.336.203.396.27.688.207.905-.065.234-.174.357-.659.748-.195.157-.377.32-.405.362a.955.955 0 0 0-.134.463c.003.342.224.962.514 1.44.226.37.629.845 1.028 1.21.47.43.883.722 1.35.954.6.298.966.374 1.234.25a.993.993 0 0 0 .162-.09c.02-.02.178-.212.35-.425.332-.417.408-.485.635-.563.289-.098.583-.071.88.08.225.117.717.422 1.034.643.418.293 1.31 1.022 1.431 1.167.213.262.25.598.107.969Z" clipRule="evenodd" />
        </svg>
    );
};
